module.exports = __webpack_public_path__ + "img/black-card.c1571fd2.png";